import { Pipe, PipeTransform } from '@angular/core';
import {TariffSize, TariffStore, TariffType} from "../../../../../tariff";

@Pipe({
  name: 'tariffPrice',
  standalone: true
})
export class TariffPricePipe implements PipeTransform {
  constructor(private tariffStore: TariffStore) {}

  transform(size: TariffSize, tariff: TariffType): string {
    return this.tariffStore.getPrice(tariff, size);
  }

}
